module.exports = __webpack_public_path__ + "static/img/invest.d5ebf4e3.png";